import React from 'react'
import {
  Grid,
  FormControl,
  FormControlLabel,
  Button,
  RadioGroup,
  Radio,
  // Select,
  // MenuItem,
  TextField,
} from '@material-ui/core'
import Stack from '@mui/material/Stack'
import './Style/crearFormulario.scss'

import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Table52 from './Tables/TablesSec5/Table52'
import Table54 from './Tables/TablesSec5/Table54'
import GantChartExtreme from './Tables/TablesSec5/TableGanttDev'

import Moment from 'moment'
import NumberFormat from 'react-number-format'
import { useFormElegibilidad } from '../../../../context/ElegibilidadContext'
import { useEligibility } from '../../../../context/EligibilityContext'

const ElegibilidadSec5View = (props) => {
  const { goToStep } = props
  const { EligibilityForm } = useFormElegibilidad()

  const [, dispatch] = useEligibility()

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 6 })
    goToStep(6)
  }

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 4 })
    goToStep(4)
  }

  return (
    <>
      <form id="sec5-form">
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">INFORMACIÓN DEL SUBPROYECTO</h1>
          <br />
        </Grid>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              5.1. Descripción del subproyecto
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel"></label>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  1. Análisis de problemas
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Análisis de problema"
                    // error={formik.errors.ProblemAnalysis}
                    customInput={TextField}
                    disabled
                    value={EligibilityForm.ProblemAnalysis}
                  ></textarea>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  2. Análisis de alternativas de solución (análisis de
                  costo-beneficio, etc.), solución propuesta y justificación.
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    id="fullName"
                    placeholder="Análisis de alternativas de solución"
                    variant="outlined"
                    disabled
                    value={EligibilityForm.ProposedSolution}
                  ></textarea>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={6} md={6}>
                <label className="responsiveLabel">
                  3. Objetivo y Actividades
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <textarea
                    id="fullName"
                    placeholder="Objetivo y Actividades"
                    variant="outlined"
                    disabled
                    value={EligibilityForm.ObjectivesActivities}
                  ></textarea>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item>
                <label className="responsiveLabel">
                  4. Narrativa sobre cómo la estrategia de adaptación propuesta
                  y las medidas de adaptación, contribuyen a abordar las
                  necesidades de adaptación y las vulnerabilidades a los
                  impactos del cambio climático y a la variabilidad climática,
                  identificadas.
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <textarea
                    id="fullName"
                    placeholder="Narrativa sobre la estrategia de adaptación
                  "
                    // error={formik.errors.ProposedStrategy}
                    variant="outlined"
                    disabled
                    value={EligibilityForm.ProposedStrategy}
                  ></textarea>
                </FormControl>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              5.2. Medidas de adaptación al cambio climático
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Seleccione la medida de adaptación a implementar por la MIPYME
                  y el área de tierra que se espera mejorar con dicha medida.
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Table52
                  idElegibilityForm={EligibilityForm.IdElegibilityAnswer}
                ></Table52>
              </Grid>

              <Grid item xs={12} sm={12} md={12}></Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              5.3. Cronograma para implementación de presupuesto{' '}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  1. Período estimado de implementación del proyecto.
                </label>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <Stack noValidate spacing={3}>
                    <TextField
                      id="date"
                      label="Desde"
                      type="date"
                      variant="outlined"
                      sx={{ width: 220 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={Moment(EligibilityForm.ImplementationDateStart)
                        .format('YYYY-MM-DD')
                        .toString()}
                      disabled
                    />
                  </Stack>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <Stack noValidate spacing={3}>
                    <TextField
                      id="date"
                      label="Hasta"
                      type="date"
                      variant="outlined"
                      sx={{ width: 220 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={Moment(EligibilityForm.ImplementationDateEnd)
                        .format('YYYY-MM-DD')
                        .toString()}
                      disabled
                    />
                  </Stack>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  2. Marque en el cronograma los meses en que se estima se
                  implementará el proyecto de acuerdo a cada actividad
                  principal.
                </label>
                <br></br>
                <br></br>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <GantChartExtreme
                  idElegibilityForm={EligibilityForm.IdElegibilityAnswer}
                ></GantChartExtreme>
              </Grid>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  3. Indique si es necesario recibir los fondos en un mes
                  específico, para poder implementar las inversiones solicitadas
                  de manera oportuna.
                  <span style={{ color: 'red' }}>*</span>
                </label>
              </Grid>

              <Grid item xs={6} sm={6} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <Stack noValidate spacing={3}>
                    <TextField
                      id="date"
                      label="Período"
                      type="date"
                      variant="outlined"
                      sx={{ width: 220 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      value={
                        EligibilityForm.FundsMonth
                          ? Moment(EligibilityForm.FundsMonth).format(
                              'YYYY-MM-DD',
                            )
                          : null
                      }
                    />
                  </Stack>
                </FormControl>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              5.4. Presupuesto
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid item xs={4} sm={4} md={4}>
              <label>Seleccione una Moneda</label>
              <FormControl fullWidth>
                <TextField
                  id="currencyBudget"
                  name="currencyBudget"
                  style={{ width: '100%' }}
                  disabled
                  variant="outlined"
                  value={EligibilityForm.CurrencyBudgetName}
                />
                {/* <Select
                  id="currencyBudget"
                  name="currencyBudget"
                  value={EligibilityForm.idSector}
                  disabled
                  variant="outlined"
                >
                  <MenuItem value={''} disabled>
                    Seleccione una opción
                  </MenuItem>
                </Select> */}
              </FormControl>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <Table54
                  idElegibilityForm={EligibilityForm.IdElegibilityAnswer}
                ></Table54>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              5.5. Ventas anuales
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Seleccione la opción que corresponde a sus ventas anuales:
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl disabled>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    value={EligibilityForm.IdAnnualSalesProject}
                  >
                    <FormControlLabel
                      value="PE"
                      disabled
                      control={<Radio />}
                      label="Proyectos existentes"
                    />
                    <FormControlLabel
                      value="PA"
                      disabled
                      control={<Radio />}
                      label="Proyectos o actividades nuevas"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={4} sm={4} md={4}>
                <FormControl style={{ width: '100%' }}>
                  <label>Ventas anuales</label>
                  <NumberFormat
                    id="fullName"
                    allowNegative={false}
                    decimalScale={2}
                    thousandSeparator={true}
                    customInput={TextField}
                    style={{ width: '100%' }}
                    variant="outlined"
                    disabled
                    value={EligibilityForm.AnnualSales}
                    inputProps={{ maxLength: 14 }}
                    fixedDecimalScale
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <label>Moneda </label>
                <FormControl fullWidth>
                  <TextField
                    id="idCurrency"
                    style={{ width: '100%' }}
                    disabled
                    variant="outlined"
                    value={EligibilityForm.CurrencyBudgetName} // Poner
                  />
                  {/* <Select
                    id="idCurrency"
                    variant="outlined"
                    // error={formik.errors.idSector}
                    value={EligibilityForm.IdCurrencyBudget}
                    // onBlur={handleCurrency}
                    disabled
                  >
                    <MenuItem value={''}>Seleccione una opción</MenuItem>

                    {currencyType &&
                      currencyType.map((item, key) => (
                        <MenuItem key={key} value={item.IdCurrency}>
                          {item.Description}
                        </MenuItem>
                      ))}
                  </Select> */}
                </FormControl>
              </Grid>
              {EligibilityForm.CurrencyAnnualSalesName &&
              EligibilityForm.CurrencyAnnualSalesName === 'Dólares' ? (
                ''
              ) : (
                <Grid item xs={4} sm={4} md={4}>
                  <FormControl style={{ width: '100%' }}>
                    <label>Ventas Anuales (USD)</label>
                    <NumberFormat
                      id="TotalSubProjectBudgetDollar"
                      name="TotalSubProjectBudgetDollar"
                      customInput={TextField}
                      thousandSeparator={true}
                      value={EligibilityForm.AnnualSalesDollar}
                      autoComplete="off"
                      disabled
                      prefix="$"
                      allowNegative={false}
                      variant="outlined"
                      isNumericString={true}
                      inputProps={{ maxLength: 18 }}
                      fixedDecimalScale
                      decimalScale={2}
                    />
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              5.6. Estrategia de género
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Proporcione información sobre cómo el subproyecto se asegurará
                  de incluir las necesidades de las mujeres, y cómo garantizará
                  que los beneficios generados sean igualmente accesibles para
                  hombres y mujeres.
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  1. ¿Cuáles son las necesidades de las mujeres dentro de la
                  MIPYME?
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Necesidades de las mujeres dentro de la MIPYME"
                    value={EligibilityForm.WomenNeeds}
                    disabled
                  ></textarea>
                </FormControl>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Grid container spacing={1}>
          <Grid container spacing={1} className="button__container">
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'left' }}
              className="continerButtonNav"
            >
              <Button
                onClick={() => previous()}
                variant="contained"
                className="button__wizard button__previous"
                // disabled={loading}
              >
                Anterior
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'right' }}
              className="continerButtonNav"
            >
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textAlign: 'right' }}
                >
                  {/* {enablePYME ? (
            <Button
              // type="submit"
              onClick={() => next()}
              className="button__wizard button__next"
              disabled={loadingExchange || exchangeError}
            >
              Siguiente
            </Button>
          ) : ( */}

                  <Button
                    onClick={() => {
                      next()
                    }}
                    className="button__wizard button__next"
                  >
                    Siguiente
                  </Button>
                  {/* )} */}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default ElegibilidadSec5View
